export interface RouteDefinition {
    definition: string;
    link(values?: never): string;
    linkForRoute: string;
}

export interface RouteDefinitionWithParameter<TParams = void> extends RouteDefinition {
    link(values?: TParams): string;
}

export interface RouteWithParameters<TParam> {
    definition: RouteDefinitionWithParameter<TParam>;
    params?: TParam;
}

export type InitialUrl<T = unknown> = string | RouteWithParameters<T>;

export function routeWithoutParameters(value: string, linkForRoute?: string): RouteDefinition {
    return {
        definition: value,
        link: () => value,
        linkForRoute: linkForRoute ?? getLinkForRoute(value),
    };
}

function getLinkForRoute(value: string): string {
    if (value.includes("/portal")) {
        return value.replace("/portal", "");
    }

    if (value.startsWith("/")) {
        return value.slice(1);
    }

    return value;
}
